import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(authenticated)/dashboard/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/admin/models" });
  },
});
